import * as turf from '@turf/turf'
export function formatValores(valor) {
  if (valor < 1000000) {
    return valor / 1000 + 'Mil'
  } else if (valor >= 1000000) {
    return valor / 1000000 + 'MI'
  }
}

export function CoordinatesToPath(geom) {
  if (!Array.isArray(geom)) {
    return []
  }

  let paths = geom
    .map(function (el) {
      const lat = Number(el?.[1])
      const lng = Number(el?.[0])
      return {lat, lng}
    })
    .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng))

  return paths
}

function isCoordinatePair(value) {
  return (
    Array.isArray(value) &&
    value.length >= 2 &&
    Number.isFinite(Number(value[0])) &&
    Number.isFinite(Number(value[1]))
  )
}

export function getFirstGeometryPathCoordinates(geojson) {
  const geometry = geojson?.type === 'Feature' ? geojson.geometry : geojson?.geometry || geojson
  let coordinates = geometry?.coordinates

  while (Array.isArray(coordinates) && coordinates.length > 0 && !isCoordinatePair(coordinates[0])) {
    coordinates = coordinates[0]
  }

  return Array.isArray(coordinates) ? coordinates : []
}

export function debounce(fn: any, ms: number) {
  let timer: any = ''
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, ms)
  }
}

export const customStylesTable = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#202124',
      fontSize: '14px',
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      // borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
    removed: {
      backgroundColor: '#ffcad3',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
  },
}

export function isAllEmpty(array) {
  return array.every(function (item) {
    return item === undefined || item === null || item === ''
  })
}

export async function fit(map, geojson) {
  if (geojson) {
    const envelope = turf.bbox(geojson)
    map.target.fitBounds(
      [
        [envelope[0], envelope[1]],
        [envelope[2], envelope[3]],
      ],
      {padding: 50}
    )
  }
  // callback(map)
}
